<template>
  <el-menu :default-active="activeMenu" :unique-opened="true" :mode="mode">
    <sidebar-item v-for="(route, index) in sidebarRouters" :key="route.path  + index" :item="route" :base-path="route.path" />
  </el-menu>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import SidebarItem from "./sideBarItem";
import { constantRoutes } from "@/router/routes";

export default {
  components: { SidebarItem },
  props: {
    mode: {
      type: String,
      default: "horizontal"
    }
  },
  data() {
    return {
      sidebarRouters: [],
    }
  },
  computed: {
    ...mapGetters(["sidebar"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
  async mounted() {
    // 项目结构仅有一个路由下有二级路由，特殊处理
    let home = constantRoutes.filter(item => item.name == "Home"); // 添加首页
    let navRouter = constantRoutes.find(item => item.headerNav);
    let navRouterPath = navRouter.path;
    this.sidebarRouters = [...home, ...navRouter.children];
    this.sidebarRouters.forEach(item => {
      if (!item.path.includes(navRouterPath) && item.name != "Home")
        item.path = navRouterPath + "/" + item.path;
    })
  }
};
</script>

<style lang="less" scoped>
.el-menu--horizontal {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &::before,
  &::after {
    display: none;
  }
}
</style>
